import script from "./TRAsyncButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TRAsyncButton.vue?vue&type=script&setup=true&lang=js"

import "./TRAsyncButton.vue?vue&type=style&index=0&id=ccfdd6de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccfdd6de"]])

export default __exports__